import { actionCreatorFactory } from '@core/utils/factories';
import { ModalMainTypes } from '@models/enums';
import {
  PaginatedResponse,
  ScopingAssociatedProjectsTabData,
  ScopingBrowseResponse,
  ScopingEquipmentTabData,
  ScopingSummaryData,
  ScopingSummaryTabData,
  UpdateScopingEquipmentData,
} from '@models/interfaces';

const actionCreator = actionCreatorFactory('SCOPING');

export namespace ScopingActions {
  export const getScopingBrowseDataAction =
    actionCreator.createAsyncAction<PaginatedResponse<ScopingBrowseResponse>>(
      'GET_SCOPING_BROWSE',
    );
  export const updateScopingBrowseDataAction = actionCreator.createAsyncAction<
    PaginatedResponse<ScopingBrowseResponse>
  >('UPDATE_SCOPING_BROWSE');
  export const updateCurrentModalTypeAction =
    actionCreator.createAsyncAction<ModalMainTypes>(
      'UPDATE_CURRENT_MODAL_TYPE',
    );
  export const getScopingSummaryAction = actionCreator.createAsyncAction<
    Omit<ScopingSummaryTabData, 'categories' | 'RAD' | 'providenceAgent'>
  >('GET_SCOPING_SUMMARY');
  export const getScopingEquipmentAction = actionCreator.createAsyncAction<
    Omit<ScopingEquipmentTabData, 'RAD'>
  >('GET_SCOPING_EQUIPMENT');
  export const getScopingAssociatedProjectsAction =
    actionCreator.createAsyncAction<ScopingAssociatedProjectsTabData>(
      'GET_SCOPING_ASSOCIATED_PROJECTS',
    );
  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');
  export const setTabLoaded = actionCreator.createAsyncAction<{
    tabName: string;
    isLoaded: boolean;
  }>('SET_TAB_LOADED');
  export const setTabError = actionCreator.createAsyncAction<{
    tabName: string;
    hasError: boolean;
  }>('SET_TAB_ERROR');
  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
  export const updateScopingSummaryAction =
    actionCreator.createAsyncAction<ScopingSummaryData>(
      'UPDATE_SCOPING_SUMMARY',
    );
  export const updateScopingEquipmentAction =
    actionCreator.createAsyncAction<UpdateScopingEquipmentData>(
      'UPDATE_SCOPING_EQUIPMENT',
    );
}
